import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { NavItem } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { compressorNameOrNumber } from "../model/Kompressor";
import PropTypes from "prop-types";

const getLinkTNR = path => {
	return {
		"/": "Home",
		"/overview": "Overview",
		"/overview/master": "Master control",
		"/overview/compressor": "Compressor control",
		"/overview/compressor/:compressorIndex/type_plate": "Type plate",
		"/overview/accessories": "Accessories",
		"/overview/accessories/master": "Master control",
		"/analysis": "Analysis",
		"/analysis/graphics": "Graphics",
		"/analysis/graphics/load_non-load_ratio": "Load / non-load ratio",
		"/analysis/graphics/motor_starts": "Motor starts",
		"/analysis/graphics/specific_power": "Specific power",
		"/analysis/graphics/energy_consumption": "Energy consumption",
		"/analysis/data_table": "Data table",
		"/analysis/data_table/load_non-load_ratio": "Load / non-load ratio",
		"/analysis/data_table/motor_starts": "Motor starts",
		"/analysis/data_table/specific_power": "Specific power",
		"/analysis/data_table/energy_consumption": "Energy consumption",
		"/think_green": "Think Green",
		"/data_archive": "Data archive",
		"/energy_balancing": "Energy Balancing",
		"/energy_balancing/energy_balance": "Energy and compressed air balance",
		"/energy_balancing/energy_consumption": "Energy consumption",
		"/energy_balancing/volume_and_leakage": "Volume and leakage",
		"/energy_balancing/heat_reclaiming": "Heat reclaiming",
		"/energy_balancing/error_log": "Error Log",
		"/energy_balancing/data_logs": "Data logs",
		"/maintenance": "Maintenance",
		"/maintenance/overview": "Overview",
		"/maintenance/compressor": "Compressors",
		"/maintenance/compressor/:compressorIndex/image": "Image",
		"/maintenance/table": "Table",
		"/error_log": "Error Log",
		"/settings": "Settings",
		"/settings/network": "Network",
		"/settings/users": "Users",
		"/settings/rights": "Rights",
		"/settings/dimensions": "Dimensions/Costs",
		"/settings/email": "E-mail",
		"/settings/print": "Print/Export",
		"/settings/time": "Time",
		"/settings/share": "Share"
	}[path] || path;
};

const checkPath = (prefix, substitution, path, match_to_element) => {
	/* prefix -> "/overview/compressor/"
	 * path -> "/overview/compressor" => nichts ändern
	 *         "/overview/compressor/" => nichts ändern (eigentlich so nicht vorgesehen)
	 *         "/overview/compressor/0" => 0 wird zu :compressorIndex, match_to_element aufrufen
	 *         "/overview/compressor/0/type_plate" 0 wird zu :compressorIndex
	 */
	if (!path.startsWith(prefix)) {
		return { path: path, generated: null };
	}
	let suffix_parts = path.substring(prefix.length).split("/");
	if (!suffix_parts.length) {
		return { path: path, generated: null };
	}

	/* suffix_parts -> ["0"]
	 *                 ["0", "anlagenpass"]
	 */
	let match = suffix_parts.splice(0, 1)[0];
	let mte = match_to_element(match);
	if (mte === null) {
		return { path: path, generated: null};
	}
	path = prefix + ":" + substitution;
	if (suffix_parts.length) {
		path += "/" + suffix_parts.join("/");
		return { path: path, generated: null};
	}
	return { path: path, generated: match_to_element(match) };
};

const compressorIndexToString = (match, compressors) => {
	let index = parseInt(match);
	if (isNaN(index)) {
		return null;
	}
	let compressor = compressors[index];
	if (!compressor) {
		return <span>{ match }</span>;
	}
	return <span>{ compressorNameOrNumber(compressor) }</span>;
};

const checkLastElement = (path, compressors) => {
	const special_paths = [
		{ prefix: "/overview/compressor/", substitution: "compressorIndex",
			generator: compressorIndexToString },
		{ prefix: "/maintenance/compressor/", substitution: "compressorIndex",
			generator: compressorIndexToString },
		{ prefix: "/overview/accessories/", substitution: "compressorIndex",
			generator: compressorIndexToString }
	];
	for (let i = 0; i < special_paths.length; ++i) {
		let sp = special_paths[i];
		let generated;
		({ path, generated } = checkPath(sp.prefix, sp.substitution, path, match => (
			sp.generator(match, compressors))));
		if (generated) {
			return { path, generated };
		}
	}
	return { path, generated: null };
};

export const getLinkElement = (path, compressors) => {
	let generated;
	({ path, generated } = checkLastElement(path, compressors));
	if (generated) {
		return generated;
	}
	return <FormattedMessage id={getLinkTNR(path)} />;
};

const AlmigLink = props => (
	<LinkContainer exact={props.exact} to={props.to} className={props.className}>
		<NavItem disabled={props.disabled}>
			{ getLinkElement(props.to) }
		</NavItem>
	</LinkContainer>
);

AlmigLink.propTypes = {
	to: PropTypes.string.isRequired,
	exact: PropTypes.bool,
	className: PropTypes.string,
	disabled: PropTypes.bool
};

AlmigLink.defaultProps = {
	disabled: false
};

export default AlmigLink;
